module.exports = __webpack_public_path__ + "static/media/lounge-pass-background.24b4f276.png";